module.exports = __webpack_public_path__ + "static/img/cooperation.010eaa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation.png
// module id = /LnP
// module chunks = 5